import { getSdk, fillLog } from '@/api/wx'
import { getLocationByAmap } from '@/api/location'
import { Promise } from 'core-js';
export function getWx() {
    return new Promise((resolve, reject) => {
        getSdk(location.href.split('#')[0]).then(res => {
            window.wx.config({
                debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
                appId: res.appId, // 必填，公众号的唯一标识
                timestamp: res.timestamp, // 必填，生成签名的时间戳
                nonceStr: res.nonceStr, // 必填，生成签名的随机串
                signature: res.signature,// 必填，签名
                jsApiList: ["getLocation", "updateAppMessageShareData", "updateTimelineShareData"] // 必填，需要使用的JS接口列表
            });
            window.wx.ready(function () {
                resolve(1)
            })

        }).catch(err => {
            console.log('err :>> ', err);
            reject(err)
        })

    })




}

export function getLocation() {
    return new Promise((resolve, reject) => {
        getWx().then((res) => {
            window.wx.getLocation({
                type: "wgs84", // 默认为wgs84的gps坐标，如果要返回直接给openLocation用的火星坐标，可传入'gcj02'
                success: function (res) {
                    var latitude = res.latitude; // 纬度，浮点数，范围为90 ~ -90
                    var longitude = res.longitude; // 经度，浮点数，范围为180 ~ -180。
                    const ll = {
                        latitude,
                        longitude,
                    };
                    resolve(ll)
                },
                fail: function (res) {
                    console.log('getLocation fail :>> ', res);
                    reject(res)
                }
            });
        });
    })

}


//division 获取用户行政位置
export function getDivision() {
    return new Promise((resolve) => {
        getLocation().then(res => {

            getLocationByAmap(res.latitude, res.longitude).then(res => {
                resolve(res)
            })

        })
    })
}








// WEBPACK FOOTER //
// ./src/utils/wxJsSdk.js